import { useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

import { useHiddenFields } from './useHiddenFields'

export const useAutoUnregister = (): void => {
  const { unregister } = useFormContext()
  const hiddenFields = useHiddenFields()
  const oldHiddenFields = useRef<string[]>([])

  useEffect(() => {
    const newHiddenFields = hiddenFields.filter((field) => !oldHiddenFields.current.includes(field))

    newHiddenFields.forEach((fieldName) => {
      unregister(fieldName)
    })

    oldHiddenFields.current = hiddenFields
  }, [hiddenFields, unregister])
}
